import { lazyConfig as config } from './config'
function getResizeParam(el) {
    const width = el.offsetWidth || el.width
    const height = el.offsetHeight || el.height
    if (width) {
        return `w_${Math.round(width * (window.devicePixelRatio || 1))}`
    } else if (height) {
        return `h_${Math.round(height * (window.devicePixelRatio || 1))}`
    }
    return null
}
// 视频截帧
function getVideoProcesser(el, param) {
    const { t } = el.dataset
    return `?x-oss-process=video/snapshot,t_${t || 6000},f_jpg,${param},m_fast`
}
// 图片处理
function getImgProcesser(param, suffix) {
    let processer = `?x-oss-process=image/resize,${param}`
    if (/^jpg|jpeg|webp$/i.test(suffix)) {
        processer += '/quality,q_80'
    }
    return processer
}
function needProcess(src) {
    const has_http = hasHttp(src)
    return src && ((has_http && src.includes('oss')) || !has_http)
}
// 获取文件后缀
function getSuffix(src) {
    let regMatch = null
    if (needProcess(src)) {
        regMatch = src.match(/\.(\w+)$/)
    }
    return regMatch && regMatch[1]
}
function isPoster(el) {
    const type = el.getAttribute('poster')
    return type != null || /video/i.test(el.tagName)
}
function hasHttp(src) {
    return /^https?|\/\//.test(src)
}
function getPrefix(el, src) {
    let p = ''
    if (!isImgEqualErr(src)&&!hasHttp(src)) {
        if (isPoster(el) || /^video$/i.test(el.tagName)) {
            p = window.env.VUE_APP_OSSVIDEO
        } else if (/^audio$/i.test(el.tagName)) {
            p = window.env.VUE_APP_OSSAUDIO
        } else {
            p = window.env.VUE_APP_OSSIMG
        }
    }
    return p || ''
}
function isImgEqualErr(img) {
    return !img || img===config.error || img===config.loading
}
function getOldSouce(el) {
    if (el.style.backgroundImage)
        return el.style.backgroundImage.match(/(https?:\/\/[^"']+)/)
    else return el.src
}
function setSource(el, source) {
    if (source) {
        const attempt = parseInt(el.getAttribute('attempt')) || 0
        if (
            (el.getAttribute('load') === 'loaded' &&
                getOldSouce(el) === source) ||
            attempt >= config.attempt
        )
            return
        let src
        const isImg = /^(img|audio)$/i.test(el.tagName)
        const isVideo = /^video$/i.test(el.tagName)
        if (isImg) {
            src = getPrefix(el, source) + source
            el.src = src
        } else if (isVideo) {
            src = getPrefix(el, source) + source
            el.src = src.split('?')[0]
            if (isImgEqualErr(el.poster)) {
                el.poster = src
            }
        } else {
            src = getPrefix(el, source) + source
            el.style.backgroundImage = `url("${src}")`
        }
        if (isImgEqualErr(src)) {
            el.setAttribute('attempt', attempt + 1)
            el.setAttribute('load', 'error')
        } else {
            el.setAttribute('load', 'loaded')
        }
    }
}
export {
    setSource,
    getSuffix,
    isPoster,
    getPrefix,
    getResizeParam,
    getVideoProcesser,
    getImgProcesser,
    needProcess
}
